<script>
    import {Row,Col,Button,Container} from 'svelte-chota';
    import {router} from 'tinro';

    export let title;
    export let button;
    export let link;
    export let type = 'primary';
    export let icon;
</script>


<Row>

{#if title}
    <Col><h4>{title}</h4></Col>
{/if}

{#if button}
    <Col class="text-right">
        <Button 
            {icon}
            primary={type=='primary'} 
            error={type=='error'} 
            on:click={()=>router.goto(link)}
        >
            {button}
        </Button>
    </Col>
{/if}

</Row>